import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mb-table',
    templateUrl: './mb-table.component.html',
    styleUrls: ['./mb-table.component.scss'],
    standalone: false
})
export class MbTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
